export const SET_PRODUCTS = 'setProducts'
export const SET_FOUND_PRODUCTS = 'setFoundProducts'
export const APPEND_PRODUCTS = 'appendProducts'
export const SET_PRODUCTS_LOADING = 'setProductsLoading'
